module.exports = __webpack_public_path__ + "static/media/31.ed0489ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/31.svg
// module id = 142
// module chunks = 0